import type { ProLayoutProps } from '@ant-design/pro-components';

/**
 * @name
 */
const Settings: ProLayoutProps & {
  pwa?: boolean;
  logo?: string;
} = {
  navTheme: 'light',
  // 拂晓蓝
  colorPrimary: '#F59120',
  layout: 'side',
  siderMenuType: 'sub',
  contentWidth: 'Fluid',
  fixedHeader: false,
  fixSiderbar: true,
  colorWeak: false,
  title: 'Moderator Dashboard',
  pwa: true,
  logo: 'https://gw.alipayobjects.com/zos/rmsportal/KDpgvguMpGfqaHPjicRK.svg',
  iconfontUrl: '',
  token: {
    sider: {
      colorBgMenuItemSelected: '#FDB71A',
      colorMenuBackground: '#00567A',
      colorTextMenu: '#ffffff',
      colorTextMenuSelected: '#000000',
      colorTextMenuActive: '#ffffff',
      colorBgMenuItemHover: '#004966',
      paddingInlineLayoutMenu: 0,
    },
    // 参见ts声明，demo 见文档，通过token 修改样式
    //https://procomponents.ant.design/components/layout#%E9%80%9A%E8%BF%87-token-%E4%BF%AE%E6%94%B9%E6%A0%B7%E5%BC%8F
  },
};

export default Settings;
